import { useQuery } from "@tanstack/react-query";
import { api } from "../config";

const getInvoiceSchedulesByTreatment = async (treatment: number | string | { id: number } | null | undefined) => {
    if (!treatment) return [];

    const treatmentId = typeof treatment === "object" ? treatment.id : treatment;

    const filter = {
        order: { treatment: { _eq: treatmentId } },
    };

    const response = await api({
        method: "GET",
        url: "/items/scheduled_invoices",
        params: {
            fields: "*.*,scheduled_invoices_items.service.*,order.order_date,order.id",
            filter: JSON.stringify(filter),
            sort: "-scheduled_date",
        },
    });

    return response.data.data;
};

export const useInvoiceSchedulesByTreatment = (treatment: number | string | { id: number } | null | undefined) => {
    const treatmentId = typeof treatment === "object" && treatment ? treatment.id : treatment;

    return useQuery({
        queryKey: ["scheduled-invoices-by-treatment", treatmentId],
        queryFn: () => getInvoiceSchedulesByTreatment(treatment),
        enabled: !!treatmentId,
    });
};

